import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=71c4dc96&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c4dc96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c4dc96')) {
      api.createRecord('71c4dc96', component.options)
    } else {
      api.reload('71c4dc96', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=71c4dc96&scoped=true&", function () {
      api.rerender('71c4dc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WcCWjE2RJEOI/JS/comp/Accordion.vue"
export default component.exports